module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo9-b89b92c1e41dbd7547fda380129fbc2e.jpg";